var map = {
  "./": "57895",
  "./accordion": "10225",
  "./accordion.js": "10225",
  "./add": "69036",
  "./add.js": "69036",
  "./destroy": "74609",
  "./destroy.js": "74609",
  "./edit": "86559",
  "./edit.js": "86559",
  "./index": "57895",
  "./index.js": "57895",
  "./show": "86838",
  "./show.js": "86838"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 14041;
